export { default } from './BouncyThumbtack';
